import React, { useState } from "react";
import { Button, useTheme, useMediaQuery } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  AssessmentTabsIndicator,
  AssessmentTabsIndicatorMobile,
} from "./AssessmentTabsIndicator";
import { getHeaderStyle } from "../../components/customstyles/HeaderStyle";
import { useAssessmentSaveAndExit } from "../../providers/AssessmentSaveAndExitProvider";
import { usePatient } from "../../providers/PatientProvider";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useEffect } from "react";
import { useAssessmentWalkthrough } from "../../providers/AssessmentWalkthroughProvider";
import { formatDateShortMonthName } from "../utilsFunctions";
import { useGuidedMode } from "../../providers/GuidedModeProvider";

const useStyles = () => {
  const theme = useTheme();
  return getHeaderStyle(theme);
};
function Header() {
  const location = useLocation();
  const { patientData } = usePatient();
  const { guidedMode } = useGuidedMode();
  const [isResultScreen, setIsResultScreen] = useState(false);
  const getNameAbbr = (patientData) => {
    let patientName = patientData.patientName.trim();
    patientName = patientName.split(" ");
    let abbr = "";
    patientName.forEach((element) => {
      abbr = abbr + element[0];
    });
    if (abbr.length > 2) {
      abbr = abbr.substring(0, 2);
    }
    return abbr;
  };

  const getAge = (patientData) => {
    let dob = patientData.birthdate;
    dob = dob.split("-");
    let year = parseInt(dob[0]);
    let currentYear = new Date().getFullYear();
    let age = currentYear - year;
    return age;
  };

  const getDob = (data) => {
    return data ? formatDateShortMonthName(patientData.birthdate) : "";
  };

  const checkIsResultScreen = () => {
    let check = location.pathname.substring(1);
    check = check.split("/");
    let result;
    try {
      result = check[check.length - 2];
      if (result === "result") {
        result = true;
      } else {
        result = false;
      }
    } catch {
      result = false;
    }
    setIsResultScreen(result);
  };
  useEffect(() => {
    checkIsResultScreen();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const styles = useStyles();
  const isMobile = useMediaQuery("(max-width: 900px)");

  let { toggleSaveAndExitModal } = useAssessmentSaveAndExit();
  const { showOrHideAssessmentWalkthrough, showOrHideCheckBox } =
    useAssessmentWalkthrough();

  return (
    <div id="header">
      <div
        id="header"
        style={{
          ...styles.header,
          justifyContent: isResultScreen ? "flex-start" : "space-around",
        }}
      >
        <div style={{ ...styles.headerNameDiv }}>
          <div
            style={{
              ...styles.nameAbbrContainer,
            }}
          >
            <p
              style={{
                ...styles.nameAbbrText,
              }}
            >
              {patientData && getNameAbbr(patientData)}
            </p>
          </div>
          <div
            style={{
              ...styles.nameDetailsContainer,
            }}
          >
            <h3 style={{ margin: 0, padding: "5px" }}>
              {patientData && patientData.patientName}
            </h3>
            <div style={{ ...styles.headerNameDiv }}>
              <p style={{ ...styles.ageAndDob }}>Age</p>
              <p
                style={{
                  ...styles.ageAndDobValue,
                }}
              >
                {patientData && getAge(patientData)}
              </p>
              <p style={{ ...styles.ageAndDob }}>DOB</p>
              <p
                style={{
                  ...styles.ageAndDobValue,
                }}
              >
                {getDob(patientData)}
              </p>
            </div>
          </div>
        </div>
        {!isMobile && !isResultScreen && (
          <div style={{ width: "40%" }}>
            {guidedMode && <AssessmentTabsIndicator />}
          </div>
        )}
        {!isResultScreen && (
          <div
            style={{
              ...styles.buttonsContainer,
            }}
          >
            <Button
              variant="outlined"
              endIcon={<HelpOutlineIcon />}
              style={{
                ...styles.button,
              }}
              onClick={() => {
                showOrHideCheckBox(false);
                showOrHideAssessmentWalkthrough(true);
              }}
            >
              Tutorial
            </Button>
            <Button
              variant="outlined"
              endIcon={<LogoutIcon />}
              style={{
                ...styles.button,
              }}
              onClick={toggleSaveAndExitModal}
            >
              Save & Exit
            </Button>
          </div>
        )}
      </div>
      {!isResultScreen && isMobile && guidedMode && (
        <div style={{ ...styles.headerForMobile }}>
          <AssessmentTabsIndicatorMobile />
        </div>
      )}
    </div>
  );
}

export default Header;
